module.exports = __webpack_public_path__ + "static/media/check_list_success.52dce698.png";